<template>
  <main>
    <div
      class="component-featured-collection"
      :style="{backgroundImage: 'url(' + fileUrl(genre.banner+'?h=400') + ')'}"
    >
      <div class="genre-banner-shadow px-2">
        <section
          class="d-flex flex-column justify-content-center align-items-center p-3"
        >
          <div class="text-white rounded pt-2">
            <template v-if="genre.icon">
            <i :class="['icon text-shadow display-1 p-3 text-white', `icon-${genre.icon}`]"/>
          </template>
          <template v-else>
            <i class="icon text-shadow display-1 icon-profile-game-controller-inactive" />
          </template>
          </div>
          <h1 class="text-white pt-2 text-shadow">
              {{ genre.name }}
          </h1>
          <p
            class="lead text-light w-100 mt-5 pt-5 mx-1 px-1"
          >{{ genre.description }}</p>
        </section>
      </div>
    </div>
    <article>
      <ProductListWithoutCarousel :products="genreProducts" />

      <b-button
        v-if="genre.products.length !== genre.totalProductsCount"
        variant="primary"
        class="d-flex justify-content-center col-md-3 col-sm-6 col-xxs-12 mb-3 mx-auto"
        @click="loadMore"
      >{{ $t('common.showMore') }}
      <img src="@/assets/loading.svg" height="25" class="px-2" v-if="isLoading"/>
      </b-button>
    </article>
  </main>
</template>

<script>
import ProductListWithoutCarousel from '@/components/ProductListWithoutCarousel.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'GameGenreDetail',
  components: {
    ProductListWithoutCarousel
  },
  data() {
    return {
      bottomOfWindow: false,
      loadMoreClicked: false,
      isLoading: false
    }
  },
  props: {
    genre: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters({
      fileUrl: 'cdn/fileUrl'
    }),
    genreProducts() {
      this.loadGenreProducts(this.genre.id)
      return this.genre.products.map(value => {
        return {
          title: value.name,
          imageUrl: value.icon,
          publisher: value.publisher ? value.publisher.name : '',
          targetUrl: '/product/' + value.id,
          genre: value.genres
            .map(g => {
              return g.name
            })
            .join(', ')
        }
      })
    }
  },
  methods: {
    ...mapActions({
      loadGenreProducts: 'productCatalog/loadGenreProducts'
    }),
    loadMore() {
      this.isLoading = true
      this.loadGenreProducts(this.genre.id)
      this.bottomOfWindow =
        document.documentElement.scrollTop + window.innerHeight ===
        document.documentElement.offsetHeight
      window.onscroll = () => {
        if (this.bottomOfWindow && this.loadMoreClicked) {
          this.$ga.event('Game', 'GamesListShowMore')
          this.loadGenreProducts(this.genre.id)
          this.isLoading = false
          }
      }
      this.loadMoreClicked = true
    }
  },
  created(){
    this.loadGenreProducts(this.genre.id)
  }
}
</script>
